import styled from 'styled-components';
import { Box } from '@rsos/base-components';

export const GISFeedbackButtonContainer = styled(Box)`
  align-items: center;
  background-color: var(--calcite-color-background-1);
  cursor: pointer;
  display: flex;
  justify-content: center;
  height: 32px;
  margin: 0 5px;
  padding: 0 8px;
  transition: all 0.2s ease;
  width: 32px;

  &:focus,
  &:hover {
    background-color: var(
      --calcite-action-background-color-hover,
      var(--calcite-color-foreground-2)
    );
  }
`;
